/** @format */

export const DEFAULT_TEST_ID = 'model-search-results';
